export default "__VITE_ASSET__D4GveAz7__"